import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Bars } from "react-loader-spinner";

function AuthLayout({ children, authentication = true }) {
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  //   const { current: authStatus } = useUser();

  const token = sessionStorage.getItem("token");
  var authStatus = false;
  if (token) {
    authStatus = true;
  }

  useEffect(() => {
    //if user is not authenticated and we want authentication like dashboard page
    if (!authStatus && authentication) {
      navigate("/admin/login");
    }
    // if user is authenticated and we did not want authentication like login page
    else if (authStatus && !authentication) {
      navigate("/");
    }

    setLoader(false);
  }, [authentication, authStatus, navigate]);

  return loader ? (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {/* <Typography>Loading ...</Typography> */}
      {/* <CircularProgress/> */}
      <Bars
        height="45"
        width="45"
        color="gray"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </Box>
  ) : (
    <>{children}</>
  );
}

export default AuthLayout;
